import { memo } from 'react';
import { StatusHorizontalProgressProps } from './StatusHorizontalProgress/StatusHorizontalProgress.types';
import StatusHorizontalProgress from './StatusHorizontalProgress/StatusHorizontalProgress';
import StatusMemberProgress from './StatusMemberProgress';
import StatusVipProgress from './StatusVipProgress';

function StatusProgress(props: StatusHorizontalProgressProps) {
  const { currentStatus, totalLoyaltyPoints } = props;

  if (currentStatus === 'Member') {
    return <StatusMemberProgress totalLoyaltyPoints={totalLoyaltyPoints} />;
  }

  if (currentStatus === 'Vip') {
    return <StatusVipProgress />;
  }

  return <StatusHorizontalProgress {...props} />;
}

export default memo(StatusProgress);
